import { toast } from 'react-toastify'
import { toastStyle } from '../stylesJS/toastStyle'

export const errorsHandler = (message?: string) => {

  toast.error(message ?? 'Ошибка получения данных, попробуйте зайти позже', toastStyle)
}
